import { getStyle, getTheme } from "customStyles/utils";
import { getLogo } from "utils/tenants";

const tenant = process.env.REACT_APP_TENANT;

const currentTheme = getTheme(tenant);
const currentLogo = getLogo(tenant);
// const currentTheme = getTheme("su");

// const currentLogo = getLogo("su");
export const settings = {
  tenant: tenant,
  noAuth: false,
  authorizationApi: process.env.REACT_APP_AUTHORIZATION_API,
  basename: "",
  authClientId: "admin",
  gatewayApi: process.env.REACT_APP_GATEWAY_API,
  homeIconStyle: currentTheme.homeIconStyle,
  logoutstyle: currentTheme.logoutStyle,
  logo: currentLogo,
  // accessResponseString: "AccessId",
  // userProfileString: "UserData",
  userNameString: "email",
  passwordString: "password",
  recaptchaString: "reCaptchaToken",
  // dataProviderVersion: "pascal",
  usesSeparatePermissions: true,
  // usesCustomPermissionValidator: true,
  // permissions: "permissions",
  // permissionsValidator: (permissions, permission) => {
  //   return permissions?.Permissions.includes(permission);
  // },
  accessTokenString: "access_token",
  // refreshTokenString: "refresh_token",
  // accessResponseString: "access_token",
  // refreshResponseString: "refresh_token",
  // refreshSessionString: "refresh_token",
  loginEndpoint: "security/external/login",
  ldapLoginAPI: process.env.REACT_APP_GATEWAY_API,
  theme: currentTheme,
  style: getStyle(process.env.REACT_APP_TENANT),
};
